"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInputRow = exports.AgeGroupsSeen = exports.HiddenInputRow = exports.TimeInputRow = exports.DateInputRow = exports.SSNInputRow = exports.TypeaheadInputRow = exports.MultiSelectInputRow = exports.TextareaInputRow = exports.CheckboxInputRow = exports.AddressInputRow = exports.SimpleSelectInputRow = exports.SelectInputRow = exports.EmailInputRow = exports.PhoneInputRow = exports.RadioInputRow = exports.InlineInputRow = exports.ArrayInputRow = exports.NameInputRow = exports.TextInputRow = exports.DOBInputRow = exports.NPIInputRow = void 0;
const react_1 = __importDefault(require("react"));
const omit_1 = __importDefault(require("lodash/omit"));
const prop_types_1 = __importDefault(require("prop-types"));
const inputs_1 = require("../inputs");
const row_1 = __importDefault(require("./row"));
const name_input_row_1 = __importDefault(require("./name-input-row")); // label is managed within <NameInputRow />
exports.NameInputRow = name_input_row_1.default;
const inline_input_row_1 = __importDefault(require("./inline-input-row")); // label is managed within <InlineInputRow />
exports.InlineInputRow = inline_input_row_1.default;
const address_input_row_1 = __importDefault(require("./address-input-row"));
exports.AddressInputRow = address_input_row_1.default;
const container_1 = __importDefault(require("./array-input-row/container"));
exports.ArrayInputRow = container_1.default;
const age_groups_seen_1 = __importDefault(require("./age-groups-seen"));
exports.AgeGroupsSeen = age_groups_seen_1.default;
const TextareaInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props),
    react_1.default.createElement(inputs_1.TextareaInput, Object.assign({}, props))));
exports.TextareaInputRow = TextareaInputRow;
const TextInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props, { width: props.width || 'l' }),
    react_1.default.createElement(inputs_1.TextInput, Object.assign({}, props))));
exports.TextInputRow = TextInputRow;
const HiddenInputRow = (props) => react_1.default.createElement(inputs_1.HiddenInput, Object.assign({}, props));
exports.HiddenInputRow = HiddenInputRow;
TextInputRow.propTypes = {
    width: prop_types_1.default.string
};
const NPIInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props, { width: props.width || 'l' }),
    react_1.default.createElement(inputs_1.NPIInput, Object.assign({}, props))));
exports.NPIInputRow = NPIInputRow;
NPIInputRow.propTypes = {
    width: prop_types_1.default.string
};
const SelectInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props, { width: props.width || 's' }),
    react_1.default.createElement(inputs_1.SelectInput, Object.assign({}, props))));
exports.SelectInputRow = SelectInputRow;
SelectInputRow.propTypes = {
    width: prop_types_1.default.string
};
const SimpleSelectInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props, { width: props.width || 's' }),
    react_1.default.createElement(inputs_1.SimpleSelectInput, Object.assign({}, props))));
exports.SimpleSelectInputRow = SimpleSelectInputRow;
SimpleSelectInputRow.propTypes = {
    width: prop_types_1.default.string
};
const CheckboxInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, (0, omit_1.default)(props, 'label')),
    react_1.default.createElement(inputs_1.CheckboxInput, Object.assign({}, props))));
exports.CheckboxInputRow = CheckboxInputRow;
const RadioInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props),
    react_1.default.createElement(inputs_1.RadioInput, Object.assign({}, props))));
exports.RadioInputRow = RadioInputRow;
const EmailInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, (0, omit_1.default)(props, 'label')),
    react_1.default.createElement(inputs_1.EmailInput, Object.assign({}, (0, omit_1.default)(props, 'label')))));
exports.EmailInputRow = EmailInputRow;
EmailInputRow.propTypes = { label: prop_types_1.default.string };
const MultiSelectInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props),
    react_1.default.createElement(inputs_1.MultiSelectInput, Object.assign({}, props))));
exports.MultiSelectInputRow = MultiSelectInputRow;
const TypeaheadInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props),
    react_1.default.createElement(inputs_1.TypeaheadInput, Object.assign({}, props))));
exports.TypeaheadInputRow = TypeaheadInputRow;
const DOBInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props, { width: props.width || 'l' }),
    react_1.default.createElement(inputs_1.DOBInput, Object.assign({}, props))));
exports.DOBInputRow = DOBInputRow;
DOBInputRow.propTypes = {
    width: prop_types_1.default.string
};
// don't pass a label to <Row />, because
// <PhoneInput /> manages its own label
const PhoneInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, (0, omit_1.default)(props, 'label'), { width: props.width || 's' }),
    react_1.default.createElement(inputs_1.PhoneInput, Object.assign({}, props))));
exports.PhoneInputRow = PhoneInputRow;
PhoneInputRow.propTypes = {
    width: prop_types_1.default.string
};
const SSNInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props),
    react_1.default.createElement(inputs_1.SSNInput, Object.assign({}, props))));
exports.SSNInputRow = SSNInputRow;
const DateInputRow = (props) => (react_1.default.createElement(row_1.default, Object.assign({}, props),
    react_1.default.createElement(inputs_1.DateInput, Object.assign({}, props))));
exports.DateInputRow = DateInputRow;
const TimeInputRow = (props) => {
    return (react_1.default.createElement(row_1.default, Object.assign({}, props),
        react_1.default.createElement(inputs_1.TimeInput, Object.assign({}, props))));
};
exports.TimeInputRow = TimeInputRow;
const FileInputRow = (props) => {
    return (react_1.default.createElement(row_1.default, Object.assign({}, props),
        react_1.default.createElement(inputs_1.FileInput, Object.assign({}, props))));
};
exports.FileInputRow = FileInputRow;
//# sourceMappingURL=index.js.map